<template>
  <div :class="'md-layout'">
    <md-dialog :md-active.sync="showDialog">
      <md-dialog-title>Update status</md-dialog-title>
      <md-dialog-content>
        Are you sure you want to update the status?
      </md-dialog-content>
      <md-dialog-actions>
        <md-button :disabled="isSending" @click.prevent="dismissDialog">Cancel</md-button>
        <md-button :class="'md-primary'" :disabled="isSending" @click.prevent="updateStatus">
          {{ !isSending ? "Update" : "Updating..." }}
        </md-button>
      </md-dialog-actions>
    </md-dialog>
    <div :class="'md-layout-item md-size-100'">
      <md-card>
        <md-card-header :class="'md-card-header-icon md-card-header-danger'">
          <div :class="'card-icon'">
            <md-icon>assignment</md-icon>
          </div>
          <h4 :class="'title'">
            List
            <md-button v-if="isAdminTI() && isAuditor()" :class="'md-simple pull-right'" :md-ripple="false" @click.prevent="exportXlsx"
              title="Print this report">
              <span>Download this report</span>
              <md-icon>download</md-icon>
            </md-button>
          </h4>
        </md-card-header>
        <md-card-content>

          <!--Filters-->
          <div :class="'md-layout'">
            <div :class="'md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-25 md-large-size-25'">
              <md-field md-clearable>
                <label>Review Reference</label>
                <md-select v-model="reference" md-dense @input="getActionPlans">
                  <md-option v-for="(rf, idx) in references" :key="idx" :value="rf.id">
                    {{ rf.reference }}
                  </md-option>
                </md-select>
              </md-field>
            </div>
            <div :class="'md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-25 md-large-size-25'">
              <md-field md-clearable>
                <label :class="'title-select'">Reviewer</label>
                <select :class="'custom-select'" placeholder="Reviewer" v-model="reviewerId" @change="getActionPlans" md-dense>
                  <option value="">Reviewer</option>
                  <option :value="user.id" v-for="(user, i) in users" :key="i">
                    {{ user.name }}
                  </option>
                </select>
              </md-field>
            </div>
            <div :class="'md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-25 md-large-size-25'">
              <md-field md-clearable>
                <label :class="'title-select'">Engagement Leader</label>
                <select :class="'custom-select'" placeholder="Engagement Leader" v-model="elId" @change="getActionPlans"
                  md-dense>
                  <option value="">Engagement Leader</option>
                  <option :value="user.id" v-for="(user, i) in users" :key="i">
                    {{ user.name }}
                  </option>
                </select>
              </md-field>
            </div>
            <div :class="'md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-25 md-large-size-25'">
              <md-field>
                <label>Status</label>
                <md-select id="status" v-model="status" @input="getActionPlans">
                  <md-option value="pending">Pending</md-option>
                  <md-option value="finished">Finished</md-option>
                  <md-option value="all">All</md-option>
                </md-select>
              </md-field>
            </div>
          </div>

          <!--Table-->
          <md-table v-model="ratings" table-header-color="orange">
            <md-empty-state md-icon="list" md-label="Action Plans" :md-description="'No action plans found' +
              (this.filtersQuery ? ' with the searched terms' : '')" v-if="!isFetching">
            </md-empty-state>
            <md-table-row slot="md-table-row" slot-scope="{ item: rating }">
              <md-table-cell md-label="Reference">{{ rating.review.advisory.reference }}</md-table-cell>
              <md-table-cell md-label="RQR Reviewer">{{ rating.review.rqr_reviewer.name }}</md-table-cell>
              <md-table-cell md-label="Engagement Leader">{{ rating.review.engagement_leader.name }}</md-table-cell>
              <md-table-cell md-label="Rating">{{ getRating(rating.rating) }}</md-table-cell>
              <md-table-cell md-label="Action Plan">{{ rating.action_plan }}</md-table-cell>
              <md-table-cell md-label="Deadline">{{ rating.action_plan_deadline | date }}</md-table-cell>
              <md-table-cell md-label="Status">{{ getStatus(rating.action_plan_status) }}</md-table-cell>
              <md-table-cell md-label="Actions" md-numeric v-if="isAdminTI() && isAuditor()">
                <md-button :class="'md-simple md-just-icon'" :md-ripple="false" @click.prevent="openDialog(rating)"
                  title="Edit status">
                  <md-icon>edit</md-icon>
                </md-button>
              </md-table-cell>
            </md-table-row>
          </md-table>
          <div :class="'md-flex text-center'" v-if="ratings.length > 0">
            <Pagination :total="pagination.totalItems" :value="pagination.currentPage" :perPage="pagination.perPage"
              @input="changePage" />
          </div>
          <div :class="'md-flex text-center'" v-if="isFetching">
            <md-progress-spinner :class="'md-accent'" :md-stroke="3" md-mode="indeterminate"></md-progress-spinner>
          </div>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>

<script>
import { Pagination } from "@/components";
import { sections, date } from "@/filters";
import { camelToSnake } from "@/methods/api/requests";
import * as utils from "@/utils";

export default {
  created() {
    if (this.$route.query.status)
      this.status = this.$route.query.status;

    this.getReferences();
    this.getActionPlans();
    this.getUsers();
  },

  data() {
    return {
      references: [],
      ratings: [],
      users: [],
      isFetching: false,
      status: "all",
      reference: "",
      reviewerId: "",
      elId: "",
      pagination: {
        totalItems: "",
        currentPage: "",
        perPage: "",
      },
      isSending: false,
      showDialog: false,
      actionPlan: {},
      errorResponses: {
        400: "The users spreadsheet is invalid",
        422: "There is an error with your file",
      },
    };
  },

  components: {
    Pagination,
  },

  computed: {
    filtersQuery() {
      let query = "";

      if (this.status)
        query += `status=${this.status}&`;

      if (this.reference)
        query += `reference=${this.reference}&`;

      if (this.reviewerId)
        query += `reviewer=${this.reviewerId}&`;

      if (this.elId)
        query += `el=${this.elId}&`;

      return query;
    },

    paginationQuery() {
      return utils.getPaginationQuery(this.pagination.currentPage);
    },
  },

  filters: {
    sections,
    date,
  },

  methods: {
    isAdminTI() {
      return this.$store.state.currentProfile !== "adminTi" ? true : false;
    },

    isAuditor() {
      return this.$store.state.currentProfile !== "audit" ? true : false;
    },

    getActionPlans() {
      this.isFetching = true;
      this.$api
        .request(`action-plans?${this.filtersQuery}${this.paginationQuery}`)
        .then((response) => {
          this.ratings = camelToSnake(response.data.data);
          this.pagination.totalItems = response.data.meta.total;
          this.pagination.currentPage = response.data.meta.currentPage;
          this.pagination.perPage = response.data.meta.perPage;
        })
        .finally(() => {
          this.isFetching = false;
        });
    },

    getReferences() {
      this.$api.request("all/advisories").then((response) => {
        this.references = camelToSnake(response.data)
          // .sort((a, b) => a.reference.localeCompare(b.reference));
      });
    },

    getUsers() {
      this.isFetching = true;
      this.$api
        .request("all/users")
        .then((response) => {
          this.users = camelToSnake(response.data)
            .filter((d) => d.inactive_user === null)
            // .sort((a, b) => a.name.localeCompare(b.name));
        })
        .finally(() => {
          this.isFetching = false;
        });
    },

    changePage(toPage) {
      if (toPage === this.pagination.currentPage)
        return;

      this.pagination.currentPage = toPage;
      this.getActionPlans();
    },

    getStatus(status) {
      if (status === 1)
        return "Finished";

      return "Pending";
    },

    getRating(rating) {
      switch (rating) {
        case 1:
          return "Compliant";
        case 2:
          return "Adequate";
        case 3:
          return "Unsatisfactory";
        default:
          return "";
      }
    },

    openDialog(actionPlan) {
      this.actionPlan = actionPlan;
      this.showDialog = true;
    },

    updateStatus() {
      if (this.isSending)
        return;

      this.isSending = true;
      const data = this.actionPlan;
      data.action_plan_status = this.actionPlan.action_plan_status ? null : 1;
      this.$api.request
        .post(`reviews/${this.actionPlan.review_id}/ratings`, data)
        .then(() => {
          this.$toast.show("Status updated successfully", "");
          this.getActionPlans();
          this.dismissDialog();
        })
        .catch(() => {
          this.$toast.warning("Please, try again.", "");
        })
        .finally(() => {
          this.isSending = false;
        });
    },

    dismissDialog() {
      this.showDialog = false;
    },

    async exportXlsx() {
      this.$api.request
        .get(`report/action-plan?${this.filtersQuery.substring(0, this.filtersQuery.length-1)}`, {
          headers: {
            "Content-Type":
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          },
          responseType: "arraybuffer",
        })
        .then((response) => {
          const url = URL.createObjectURL(
            new Blob([response.data], {
              type: "application/vnd.ms-excel",
            })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "action-plan.xlsx");
          document.body.appendChild(link);
          link.click();
        })
        .catch(async (err) => {
          const errJson = await new Promise((resolve) => {
            const reader = new FileReader();
            reader.onloadend = (e) => {
              resolve(JSON.parse(e.target.result));
            };
            reader.readAsText(err.response.data);
          });
          return errJson;
        });
    },
  },
};
</script>
